<template>
  <!--tyle="clear: both" 这样可以看到浮动的元素-->
  <div class="container" style="clear: both">
    <!--标签,类似笔的形状-->
    <div class="personal-right-inner-pen-panel">
      <div class="pen-tag-icon">
        <span class="pen-tag-icon-left"></span>
        <span class="pen-tag-icon-center">
          <div class="pen-tag">{{ text }}</div>
        </span>
        <span class="pen-tag-icon-right"></span>
      </div>
      <div class="expand-slot-panel-and-closable-tag">
        <span v-if="closAble" id="closAbleTag" ref="closAbleTag" class="closAbleTag iconfont"
              @click="closAbleHandler()">
        </span>
        <span class="expand-slot-panel" ref="expand-slot">
          <slot name="expand"></slot>
        </span>
      </div>

    </div>
    <div class="pen-container" id="pen-container" ref="penPanel">
      <el-collapse-transition>
        <div v-show="closeStatus" :style="maxHighAble ? `max-height: ${maxHigh}` : ''" style="overflow: auto; ">
          <slot></slot>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>

export default {
  name: "PenPanel",
  inject: {
    penGroup: {
      type: Object,
      default: null
    },
  },
  props: {
    //面板的名称
    text: {
      type: String,
    },
    //是否可关闭
    closAble: {
      type: Boolean,
      default: false
    },
    //面板默认状态
    defaultStatus: {
      type: Boolean,
      default: true,
    },
    //拓展按钮是否随着面板收起隐藏
    expandClosAble: {
      type: Boolean,
      default: true
    },

    //面板的唯一标识
    name: {
      type: String,
      default: null,
    },

    //最大高度
    maxHigh: {
      type: String,
      default: "300px",
    },

    //面板最大高度是否生效
    maxHighAble: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      closeStatus: this.defaultStatus,
      customHeight: '0px',
    }
  },
  watch: {

    activeNames(newVal) {
      this.closeStatus = newVal.indexOf(this.name) > -1
      this.changeControlBtnStatus()
    },

  },

  computed: {
    activeNames() {
      if (this.penGroup) {
        return this.penGroup.activeNames
      }
      return []
    }
  },

  mounted() {
    this.initPage()
    if (this.penGroup) {
      let active = this.penGroup.activeNames;
      if (active) {
        this.closeStatus = active.indexOf(this.name) > -1
      }
    }
  },

  methods: {

    initPage() {
      this.changeControlBtnStatus()
      if (this.closeStatus) {
        this.$refs.closAbleTag.classList.add("closAbleTagReRotate")
      }
    },

    changeControlBtnStatus(status) {
      if (this.closAble) {
        // 关闭面板
        if (!this.closeStatus || status) {
          //按钮的动画
          this.$refs.closAbleTag.classList.remove("closAbleTagReRotate")
          this.$refs.closAbleTag.classList.add("closAbleTagRotate")

        } else {
          //打开面板
          this.$refs.closAbleTag.classList.remove("closAbleTagRotate")
          this.$refs.closAbleTag.classList.add("closAbleTagReRotate")

        }
      }
    },


    //关闭标签的关闭事件
    closAbleHandler(status) {
      if (status === true) {
        this.closeStatus = true
      } else if (status === false) {
        this.closeStatus = false
      }  else {
        this.closeStatus = !this.closeStatus
      }
      this.changeControlBtnStatus();
      if (this.expandClosAble) {
        if (this.closeStatus) {
          this.$refs["expand-slot"].style.display = "flex"
        } else {
          this.$refs["expand-slot"].style.display = "none"
        }
      }
      if (this.penGroup) {
        this.penGroup.accordionChange(this.name)
      }
    }
  }
}
</script>

<style id="PenStyle" scoped>
/*标签,类似笔的形状*/
.personal-right-inner-pen-panel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  width: 100%;
  border-radius: 10px;

}

.personal-right-inner-pen-panel:before {
  content: '';
  position: absolute;
  height: 40px;
  width: 100%;
  background-color: #eef5fc;
}

.pen-tag {
  padding-right: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
  line-height: 40px;
  margin: 0 auto;
  display: block;
  /*设置字体之间的间距*/
  text-align-last: justify
}


.container {
  width: 100%;
  margin: 10px 0;
  padding: 10px 0 0 0;
  position: relative;
  background-color: white;

}

.closAbleTag {
  position: relative;
  /*设置对齐方式,否则可能文字不对齐*/
  /*vertical-align: top;*/
  float: right;
  margin: 0 30px;
}

.closAbleTag:before {
  text-align: center;
  display: inline-block;
  height: 40px;
  width: 60px;
  cursor: pointer;
  line-height: 40px;
  content: '\e601';
  color: #3ad4ee;
  font-weight: bold;
  font-size: 20px;
}

.closAbleTagRotate {
  transform: rotate(0deg);
  transition-duration: 300ms;
}

.closAbleTagReRotate {
  transform: rotate(180deg);
  transition-duration: 300ms;
}

.pen-container {
  background-color: white;
  overflow: hidden;
}

.expand-slot-panel {
  z-index: 2;
  display: flex;
  height: 40px;
  overflow: hidden;
  float: right;
  flex-direction: row;
  align-items: center;
  transition: 200ms all;
}

.pen-tag-icon {
  display: flex;
  flex-direction: row;
}

.pen-tag-icon-left {
  z-index: 1;
  background-color: #3ad4ee;
  width: 25px;
  height: 40px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;

}

.pen-tag-icon-center {
  z-index: 1;
  background-color: #3ad4ee;
  height: 40px;
  min-width: 100px;
  color: white;
  line-height: 40px;
  font-size: 18px;
  display: inline-block;

}

.pen-tag-icon-right {
  width: 25px;
  height: 40px;
  z-index: 1;
  background-image: url("../../../static/images/pen-tag-image-right.png");
  background-size: contain;
  background-repeat: no-repeat;

}

.expand-slot-panel-and-closable-tag {
  z-index: 1;
}


</style>



// WEBPACK FOOTER //
// src/components/custom/PenPanel.vue